import TableCheck from "../TableCheck";
import { Dropdown } from "react-bootstrap";
import UserHavePermission from "../../../util/UserHavePermission";
import { mainPermissions } from "../../../util/MenuLinks";
import { formatDate } from "../../../util/format";

const HnResponsiblesColumns = [
    {
        Label: TableCheck,
        Component: TableCheck

    },
    {
        Label: () => 'id',
        accessor: 'id'
    },
    {
        Label: () => 'Usuario',
        Component: ({ value }) => value?.user?.name || '--'
    },
    {
        Label: () => 'Servicio',
        Component: ({ value }) => value?.service?.name || '--'
    },
    {
        Label: () => 'Tipo',
        Component: ({ value }) => value?.type || '--'
    },
    {
        Label: () => 'Fecha de Creación',
        Component: ({ value }) => formatDate(value?.created_at)
    },
    {
        Label: () => 'Acciones',
        Component: ({ value, onDelete }) => {
            return (
                <Dropdown className="dropdown ms-auto text-right">
                    <Dropdown.Toggle
                        variant=""
                        className="btn-link i-false"
                        data-toggle="dropdown"
                    >
                        <svg
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                        >
                            <g
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                            >
                                <rect x={0} y={0} width={24} height={24} />
                                <circle fill="#000000" cx={5} cy={12} r={2} />
                                <circle fill="#000000" cx={12} cy={12} r={2} />
                                <circle fill="#000000" cx={19} cy={12} r={2} />
                            </g>
                        </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdown-menu dropdown-menu-right">
                        {
                            UserHavePermission(mainPermissions?.hnResponsibles[3]) &&
                            <Dropdown.Item onClick={() => onDelete(value)}>
                                Eliminar
                            </Dropdown.Item>
                        }
                        {
                            UserHavePermission(mainPermissions?.hnResponsibles[2]) &&
                            <Dropdown.Item href={`/responsables/hn/actualizar/${value?.id}`}>
                                Actualizar
                            </Dropdown.Item>
                        }
                    </Dropdown.Menu>
                </Dropdown>
            )
        }
    }
];

export default HnResponsiblesColumns;